import React, { useRef, useState } from 'react';
import { IonModal } from '@ionic/react';
import { OverlayEventDetail } from '@ionic/core/components';
import {
	CloseButton,
	ForwardArrow,
	VTModalInner,
	VTSwiper,
	VTSwiperSlide,
} from './virtualTourStyles';
import { close } from 'ionicons/icons';
import IntroSlide from './IntroSlide/IntroSlide';
import OutroSlide from './OutroSlide/OutroSlide';
import { v4 } from 'uuid';
import { Trail } from '../../../models/Trail';
import { Pagination } from 'swiper';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import SlideHandler from './SlideHandler';
import { ForwardArrowIcon } from '../../Global/Icons/Icons';
import DescriptionBottomSheet from './partials/DescriptionBottomSheet';

type VirtualTourProps = {
	isOpen: boolean;
	setIsOpen: React.Dispatch<React.SetStateAction<any>>;
	// points: IMapPoint[];
	trail: Trail;
};

const VirtualTour: React.FC<VirtualTourProps> = ({
	isOpen,
	setIsOpen,
	// points,
	trail,
}) => {
	// ! TODO: REPLACE WITH USE CONTEXT AS THIS IS CAUSING RERENDERS :S
	const [sheetOpen, setSheetOpen] = useState(false);
	const [description, setDescription] = useState<any>('');
	const vtPoints = trail.waypoints.filter((point) => {
		return point.is_poi;
	});
	const virtualTour = useRef<HTMLIonModalElement>(null);

	const onWillDismiss = (ev: CustomEvent<OverlayEventDetail>) => {
		if (ev.detail.role === 'confirm') {
		}
	};
	return (
		<IonModal
			isOpen={isOpen}
			ref={virtualTour}
			onWillDismiss={(ev: CustomEvent<OverlayEventDetail>) =>
				onWillDismiss(ev)
			}
			keepContentsMounted={true}>
			<VTModalInner>
				<VTSwiper
					pagination={{
						type: 'progressbar',
					}}
					modules={[Pagination]}>
					<>
						<VTSwiperSlide>
							<IntroSlide trail={trail} />
						</VTSwiperSlide>
						{vtPoints.map((point) => {
							return (
								<VTSwiperSlide key={v4()}>
									<SlideHandler
										setDescription={setDescription}
										setSheetOpen={setSheetOpen}
										point={point}
										title={trail.title}
									/>
								</VTSwiperSlide>
							);
						})}
						<VTSwiperSlide>
							<OutroSlide trail={trail} />
						</VTSwiperSlide>
					</>
				</VTSwiper>
				<ForwardArrow>
					<ForwardArrowIcon />
				</ForwardArrow>
				<CloseButton onClick={() => setIsOpen(false)} icon={close} />
				<DescriptionBottomSheet
					sheetOpen={sheetOpen}
					setSheetOpen={setSheetOpen}
					description={description}
				/>
			</VTModalInner>
		</IonModal>
	);
};

export default VirtualTour;
